import React from "react";
import { FloatingLabel, Form, InputGroup } from "react-bootstrap";
import HelpButton from "../HelpContent/HelpButton";
import MyIcon from "../Common/MyIcon";
import EmailIcon from "../../assets/icons/icon_email-01.svg2";
import VoiceIcon from "../../assets/icons/icon_voice_tel-01.svg2";
import ImageUploadInput from "../Builder/nodes/Logic/Inputs/ImageUploadInput";
import MyCollapse from "../Common/MyCollapse";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import NewFeature from "../Builder/Components/NewFeature";

export default function EmailSendSettings({
  handleCommunicationDefaults,
  communicationDefaults,
  setCommunicationDefaults,
  disabled,
}) {
  return (
    <div className="pt-2">
      <>
        <h5 className="d-flex align-items-center">
          <MyIcon Icon={EmailIcon} width={35} className="me-2" />
          <span className="ms-2">
            <span className="fw-bold me-2">Email Send Settings</span>
            <HelpButton helpKey="settings-email-send-settings" />
            <div className="small text-secondary">
              These settings control options related to outbound email sending.
            </div>
          </span>
        </h5>
      </>
      <hr className="my-3 text-secondary" />
      <div className="row">
        <div className="col-6">
          <FloatingLabel label=" From Name:" className="mb-2">
            <Form.Control
              placeholder="This is a message from logic:"
              name="EmailFrom"
              onChange={handleCommunicationDefaults}
              value={communicationDefaults.EmailFrom}
            />
            <div className="me-2 position-absolute top-50 end-0 translate-middle-y">
              <HelpButton helpKey="settings-email-send-settings-from-name" />
            </div>
          </FloatingLabel>
          <FloatingLabel label=" Default Subject:" className="mb-2">
            <Form.Control
              placeholder="Default Subject:"
              name="EmailSubject"
              onChange={handleCommunicationDefaults}
              value={communicationDefaults.EmailSubject}
            />
            <div className="me-2 position-absolute top-50 end-0 translate-middle-y">
              <HelpButton helpKey="settings-email-send-settings-default-subject" />{" "}
            </div>
          </FloatingLabel>
          <FloatingLabel label=" Signature:" className="mb-2">
            <Form.Control
              placeholder="Message sent from logic:"
              name="EmailSignature"
              onChange={handleCommunicationDefaults}
              value={communicationDefaults.EmailSignature}
            />
            <div className="me-2 position-absolute top-50 end-0 translate-middle-y">
              {" "}
              <HelpButton helpKey="settings-email-send-settings-signature" />
            </div>
          </FloatingLabel>
          <NewFeature>
            <div className="bg-white p-3 rounded-3 mb-2">
              <div className="mb-2">Reply forward Options: </div>
              <div>
                <Input
                  isMulti
                  inputType="select"
                  value={communicationDefaults.ReplyOptions || []}
                  onChange={(v) =>
                    setCommunicationDefaults((p) => ({
                      ...p,
                      ReplyOptions: v,
                    }))
                  }
                  options={[
                    { value: "boommail", label: "Boommail" },
                    { value: "sms", label: "SMS" },
                    { value: "Email", label: "Email" },
                    { value: "api", label: "API" },
                  ]}
                  isDisabled={disabled}
                />
              </div>
            </div>
          </NewFeature>
        </div>
        <div className="col-6">
          <NewFeature>
            <InputGroup>
              <FloatingLabel className=" mb-2">Spell check</FloatingLabel>

              <Form.Check // prettier-ignore
                type="switch"
                id="spellCheck-switch"
                name="spellCheck"
                checked={communicationDefaults.SpellCheck}
                onChange={() =>
                  setCommunicationDefaults((p) => ({
                    ...p,
                    spellCheck: !p.spellCheck,
                  }))
                }
              />
            </InputGroup>
            <InputGroup>
              <FloatingLabel className=" mb-2"> Ai prompting</FloatingLabel>

              <Form.Check // prettier-ignore
                type="switch"
                id="aiPrompting-switch"
                name="aiPrompting"
                checked={communicationDefaults.aiPrompting}
                onChange={() =>
                  setCommunicationDefaults((p) => ({
                    ...p,
                    aiPrompting: !p.aiPrompting,
                  }))
                }
              />
            </InputGroup>
            <InputGroup>
              <FloatingLabel className=" mb-2"> Add a tag</FloatingLabel>

              <Form.Check // prettier-ignore
                type="switch"
                id="addATag-switch"
                name="addATag"
                checked={communicationDefaults.addATag}
                onChange={() =>
                  setCommunicationDefaults((p) => ({
                    ...p,
                    addATag: !p.addATag,
                  }))
                }
              />
            </InputGroup>
            <InputGroup>
              <FloatingLabel className=" mb-2"> Attachments</FloatingLabel>

              <Form.Check // prettier-ignore
                type="switch"
                id="attachments-switch"
                name="attachments"
                checked={communicationDefaults.attachments}
                onChange={() =>
                  setCommunicationDefaults((p) => ({
                    ...p,
                    attachments: !p.attachments,
                  }))
                }
              />
            </InputGroup>
            <InputGroup>
              <FloatingLabel className=" mb-2"> Do not reply</FloatingLabel>

              <Form.Check // prettier-ignore
                type="switch"
                id="doNotReply-switch"
                name="doNotReply"
                checked={communicationDefaults.doNotReply}
                onChange={() =>
                  setCommunicationDefaults((p) => ({
                    ...p,
                    doNotReply: !p.doNotReply,
                  }))
                }
              />
            </InputGroup>{" "}
          </NewFeature>
        </div>
        {/* <FloatingLabel label="Footer logo:" className="mb-2">
          <Form.Control
            placeholder="Footer Logo:"
            name="EmailImage"
            onChange={handleCommunicationDefaults}
            value={communicationDefaults.EmailImage}
            as="textarea"
            style={{ height: 200 }}
          />
          <div className="me-2 position-absolute top-50 end-0 translate-middle-y">
            <HelpButton />
          </div>
        </FloatingLabel> */}
        {/* <div className="p-3 rounded-3 bg-white">
          <label>Company logo</label>
          <ImageUploadInput
            value={communicationDefaults.EmailImage}
            onChange={(url) =>
              setCommunicationDefaults((p) => ({ ...p, EmailImage: url }))
            }
          />
        </div> */}
      </div>

      <hr className="my-3 text-secondary" />
    </div>
  );
}
